// Herkese açık hesap silme sayfasının (Google Play "Data deletion" şartı) API
// katmanı. Bkz. docs/hesap-silme-sayfasi.md
//
// Neden `api/client.js` DEĞİL:
//  - client.js her isteğe localStorage'daki bearer'ı ekler ve 401'de
//    refresh→retry yapar; burada kullanıcı uygulamada oturum açmamış olabilir
//    (hatta uygulamayı hiç kurmamış olabilir) ve token'ın storage'a yazılması
//    yasak — sayfanın tek işi silme, oturum taşımıyor.
//  - Silme çağrısındaki 401 "token süresi doldu → tekrar giriş yap" demektir;
//    global forceLogout akışını tetiklemesi istenmez.
// Bu yüzden interceptor'sız, ayrı bir axios örneği kullanılır; token yalnızca
// çağıran bileşenin belleğinde (React state) durur.

import axios from 'axios';
import { ApiError } from '../../api/unwrap';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.utkanesim.com',
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Platform: 'web',
  },
});

const language = () => (localStorage.getItem('i18nextLng') || 'tr').split('-')[0];

// Ağ hatası ile HTTP hatasını ayırır: status null ⇒ sunucuya ulaşılamadı.
const toError = (error) => {
  const res = error.response;
  if (!res) {
    return new ApiError('network', { status: null, code: 'NETWORK' });
  }
  const body = res.data || {};
  return new ApiError(body.error || body.message || 'request failed', {
    status: res.status,
    code: body.code || null,
  });
};

// POST /auth/login → accessToken (1 saat geçerli, yalnızca bellekte tutulur)
// 401 = e-posta/şifre hatalı · 403 = hesap askıya alınmış
export const loginForDeletion = async ({ email, password }) => {
  try {
    const res = await client.post(
      '/auth/login',
      { emailOrPhone: email, password },
      { headers: { 'Accept-Language': language() } }
    );
    const token = res.data?.data?.accessToken;
    if (!token) throw new ApiError('missing token', { status: res.status });
    return token;
  } catch (error) {
    if (error instanceof ApiError) throw error;
    throw toError(error);
  }
};

// POST /users/delete — gövde YOK, silinecek hesap token'dan okunur.
// 200 ACCOUNT_DELETED · 404 ACCOUNT_NOT_FOUND (zaten silinmiş → başarı sayılır)
// 401/403 → oturum düştü, tekrar giriş · 500 DELETION_FAILED
// → { retainedOrders, retainedEsims }
export const deleteAccountWithToken = async (accessToken) => {
  try {
    const res = await client.post('/users/delete', null, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Accept-Language': language(),
      },
    });
    return res.data?.data || {};
  } catch (error) {
    // Hesap zaten yoksa istenen sonuç zaten sağlanmış demektir.
    if (error.response?.status === 404) return {};
    throw toError(error);
  }
};
